// extracted by mini-css-extract-plugin
module.exports = {"playButton":"styles__playButton___1Ivi4","playButtonLabel":"styles__playButtonLabel___2tcNa"};